export default __webpack_public_path__ + "static/media/cameraSmallYono.2b693a4a.png";